import { render, staticRenderFns } from "./form-item-file-input.vue?vue&type=template&id=e6a41156&scoped=true&"
import script from "./form-item-file-input.vue?vue&type=script&lang=js&"
export * from "./form-item-file-input.vue?vue&type=script&lang=js&"
import style0 from "./form-item-file-input.vue?vue&type=style&index=0&id=e6a41156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a41156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VChip,VInput})
